import api from "./interceptorServices"
import { API_URL_LINK } from "./ApiURL"

const API_URL = API_URL_LINK
const NAP_URL = "https://api.ecmain2.net/api/"
// const API_URL = "http://localhost:8000/api/"

const SaveBets = async (body) => {
  try {
    const { data } = await api.post(`${API_URL}bet/add`, body)
    return data
  } catch (error) {
    console.log(error)
  }
}

const HotNum = async () => {
  try {
    const { data } = await api.get(`${NAP_URL}hotnumbers/getdata`)
    return data
  } catch (error) {
    console.log(error)
  }
}

const KeyCode = async () => {
  try {
    const { data } = await api.get(`${NAP_URL}keycode/getdata`)
    return data
  } catch (error) {
    console.log(error)
  }
}

export { SaveBets, HotNum, KeyCode }
